import { AppColor, AppColorContainer } from "../AppColorContainer";

/** This is the color container dark mode implementation used by getAppColorContainer interface implementation for Word app */
export class DarkModeWordAppColorContainer implements AppColorContainer {
  darkLabelColor: AppColor = { value : "#FAF9F8" };

  mediumLabelColor: AppColor = { value : "#EDEBE9" };

  lightLabelColor: AppColor = { value : "#D2D0CE" };

  timestampLabelColor: AppColor = { value: "#F3F2F1" };

  linkColor: AppColor = { value: "#82ABF1" };

  defaultBackgroundColor: AppColor = { value: "#292827" };

  lightBackgroundColor: AppColor = { value: "#3B3A39" };

  darkBackgroundColor: AppColor = { value: "#161514" };

  primaryWidgetColor: AppColor = { value: "#2552A4" };

  primaryWidgetColorOnHover: AppColor = { value: "#3A70DE" };

  primaryWidgetLabelColor: AppColor = { value: "#ffffff" };

  secondaryWidgetColor: AppColor = { value: "#3B3A39" };

  secondaryWidgetColorOnHover: AppColor = { value: "#1D1C1B" };

  secondaryWidgetLabelColor: AppColor = { value: "#FFFFFF" };

  secondaryWidgetLabelColorOnHover: AppColor = { value: "#598FEC" };

  secondaryWidgetBorderColor: AppColor = { value:  "#797775" };

  blackColor: AppColor = { value: "#ffffff" };

  whiteColor: AppColor = { value: "#292827" };

  wordBlue: AppColor = { value: "#2e6ac5" };

  keyboardFocusColor: AppColor = { value: "#A3A09E" };

  lightBlue: AppColor = { value: "#0078d4" };

  tagBlue: AppColor = { value: "#2E6AC5" };

  bulletGray: AppColor = { value: "#4D4D4D" };

  progressBackground: AppColor = { value: "#545352" };

  popupBackground: AppColor = { value: "#B7D1FF" };

  transcribeIllustrationHeadsetInnerColor: AppColor = { value: "#FEFEFE" };

  transcribeIllustrationHeadsetOuterColor: AppColor = { value: "#DCDCDC" };

  transcribeIllustrationHeadsetWireColor: AppColor = { value: "#3E8EED" };

  transcribeIllustrationCatLegsColor: AppColor = { value: "#72ACF1" };

  transcribeIllustrationCatBodyGradientStartColor: AppColor = { value: "#3395e5" };

  transcribeIllustrationCatBodyGradientEndColor: AppColor = { value: "#72acf1" };

  transcribeIllustrationCatTailGradientStartColor: AppColor = { value: "#3395e5" };

  transcribeIllustrationCatTailGradientEndColor: AppColor = { value: "#72acf1" };

  micWidgetBorderColor: AppColor = { value: "#2b579a" };

  // TODO: change color as per word
  charcoalColor: AppColor = { value: "#333333" };

  darkGrayColor: AppColor = {value: "#404040"};

  transcriptionIndicatorTextColor: AppColor  = {value: "#9E9E9E"};

  officeDesktopBackgroundColor: AppColor = {value: "#000000"};

  recordingIconRingsColor: AppColor = {value: "#233452"};

  listeningIconOuterColor: AppColor = {value: '#296FE6'};

  listeningIconMicColor: AppColor = {value: '#292929'};

  pauseIconOuterColor: AppColor = {value: '#000000'};

  pauseIconMicColor: AppColor = {value: '#296FE6'};

  oneDriveInfoTextColor: AppColor = {value: '#FFFFFF'};

  dropDownSelectionColor: AppColor = {value: '#979797'};

  dropDownHoverColor: AppColor = {value: '#626161'};

  private static instance: DarkModeWordAppColorContainer | null = null;

  static GetInstance() {
    if (this.instance == null) this.instance = new DarkModeWordAppColorContainer();

    return this.instance;
  }
}